<template>
	<!--
    	作者：YX
    	时间：2017-10-10
    	描述：电表档案
    -->
	<div class="meter-flie">
		<!--<el-button type="info" @click="addCode()" class="add_meter_code">增加电表档案</el-button>-->
		<addMeterCode v-if='showMeterCode' v-on:watchClose="meterCodeClose"></addMeterCode>
		
		<div class="meterCode_search" style="margin-top: 20px ;">
			<el-form :inline="true" :model="select" class="demo-form-inline" @keyup.enter.native="search">
				<el-form-item label="户号">
					<el-input v-model="select.account" placeholder="户号" style="width:200px;" :maxlength="12"></el-input>
				</el-form-item>
				<el-form-item label="表号">
					<el-input v-model="select.code" placeholder="表号" style="width:200px;" :maxlength="12"></el-input>
				</el-form-item>
				<el-form-item label="业主类型">
					<el-select v-model="select.nature" placeholder="请选择" style="width: 200px;">
						<el-option v-for="item in natures" :key="item.num" :label="item.value" :value="item.num">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="业主姓名">
					<el-input v-model="select.owner_name" placeholder="业主姓名" style="width:200px;"></el-input>
				</el-form-item>
				<!--<el-form-item label="业主手机号">
					<el-input v-model="select.owner_phone" placeholder="业主手机号" style="width:200px;" :maxlength="11"></el-input>
				</el-form-item>-->
				<el-form-item label="表类型">
					<el-select v-model="select.type" placeholder="请选择" style="width: 200px;">
						<el-option v-for="item in types" :key="item.id" :label="item.label" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="地址">
					<el-input v-model="select.address" placeholder="地址" style="width:200px;"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="search">查询</el-button>
					<el-button type="primary" @click="resetting">重置</el-button>
					<el-button type="primary" @click="downCode()">导出</el-button>
				</el-form-item>
			</el-form>
		</div>
		<el-table :data="lists" border style="width:1675px;text-align:center;margin-bottom: 10px;font-size:12px; " v-on:sort-change="sortChange">
			<el-table-column prop="account" label="户号" width="123" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="code" label="表号" width="123" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="type" label="表类型" width="115" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="nature" label="业主类型" width="107" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="owner_name" label="业主姓名" width="158" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="quota" label="限制额度" width="110" align="center" sortable="custom">
				<template scope="scope">
					{{scope.row.quota == -1 ? '不限制' : scope.row.quota}}
				</template>
			</el-table-column>
			<!--<el-table-column prop="owner_phone" label="业主手机" width="123" align="center" sortable="custom">
			</el-table-column>-->
			<el-table-column prop="create_time" label="开户时间" width="180" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="status" label="状态" width="90" align="center" sortable="custom">
				<template scope="scope">
					<el-tag v-if="scope.row.status == '正常' " type="success">正常</el-tag>
					<el-tag v-if="scope.row.status == '禁用' " type="danger">禁用</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="power_status" label="通断状态" width="120" align="center" sortable="custom">
				<template scope="scope">
					<el-tag v-if="scope.row.power_status == '通电' " type="success">通</el-tag>
					<el-tag v-if="scope.row.power_status == '断电' " type="danger">断</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="address" label="地址" width="290" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="prop" label="计量方案" width="185" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="rate" label="倍率" width="83" align="center" sortable="custom">
			</el-table-column>
			<el-table-column prop="" label="操作" width="100" align="center">
				<template scope="scope">
					<el-button type="primary" size="mini" @click="infoCode(scope.$index,scope.row)">修改详情</el-button>
					<!-- <el-button type="primary" size="mini" @click="resetCode(scope.$index,scope.row)">重置查询密码</el-button> -->
					<!--<el-button type="primary" size="mini" @click="banCode(scope.$index,scope.row)"width="260"
							v-if="scope.row.status=='正常'"
							>禁用电表</el-button>
						<el-button type="primary" size="mini" @click="qiCode(scope.$index,scope.row)"
							v-if="scope.row.status=='禁用'"
							>激活电表</el-button>-->
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pageSize" layout="total,prev, pager, next" :total="total">
		</el-pagination>
		<changeCode v-on:Close="changeClose" v-if="showChangeCode" :codeId="meterCodeId" :typess='natures'></changeCode>
	</div>
</template>

<script>
	import {mapState } from 'vuex'
	import addMeterCode from '@/components/addMeterCode'
	import changeCode from '@/components/changeCode'
	export default {
		name: 'meter-file',
		data() {
			return {
				showMeterCode: false,
				showChangeCode: false,
				prop:'',
				order:'',
				select: {
					code: '',
					owner_name: '',
					owner_phone: '',
					type: '',
					nature: '',
					address:'',
					account: '',
				},
				lists: [],
				meterCodeId: '',
				total: 0,
				pageSize: 15,
				currentPage: '',
				types: [
					{
						id: '7',
						label: '水表'
					},
					{
						id: '10',
						label: '多功能单相'
					},
					{
						id: '11',
						label: '多功能三相'
					}
				],
				natures: [/*{
						num: '0',
						value: '居民',
					},
					{
						num: '1',
						value: '自营'
					},
					{
						num: "2",
						value: '联营'
					},
					{
						num: '3',
						value: '出租'
					},
					{
						num:'4',
						value:'物业动力'
					},
					{
						num:'5',
						value:'居民配套'
					},
					{
						num: '9',
						value: '备用'
					},*/

				],
			}
		},
		created:function(){
			this.searchNature()
			this.search()
		},
		methods: {
			searchNature(){
				this.$jssdk.member.getNature({
					
				},(res) =>{
					this.natures = res
				})
			},
			sortChange(item) {
				var order = item.order
				var prop = item.prop
				this.prop = prop
				this.order = order
				let code = this.select.code
				let account = this.select.account
				let name = this.select.owner_name
				let phone = this.select.owner_phone
				let type = this.select.type
				let nature = this.select.nature
				let page = this.currentPage
				let address = this.select.address
				this.$jssdk.file.list({
					code: code,
					account: account,
					owner_name: name,
					owner_phone: phone,
					type: type,
					page: page,
					nature: nature,
					sort_by: prop,
					sort_to: order,
					address:address,
				}, (data) => {
					this.lists = data.meterList.data
					this.total = data.meterList.total
					for(var i = 0; i < data.meterList.data.length; i++) {
						if(data.meterList.data[i].nature == '0') {
							this.lists[i].nature = '居民'
						}
						if(data.meterList.data[i].nature == '1') {
							this.lists[i].nature = '自营'
						}
						if(data.meterList.data[i].nature == '2') {
							this.lists[i].nature = '联营'
						}
						if(data.meterList.data[i].nature == '3') {
							this.lists[i].nature = '出租'
						}
						if(data.meterList.data[i].nature == '4'){
							this.lists[i].nature = '物业动力'
						}
						if(data.meterList.data[i].nature == '5'){
							this.lists[i].nature = '居民配套'
						}
						if(data.meterList.data[i].nature == '9') {
							this.lists[i].nature = '备用'
						}
					}
					this.currentPage = data.meterList.current_page
				}, (err) => {
					return this.$message({
						type: 'warning',
						message: err.msg,
						duration: 1000
					})
				})
			},
			addCode() {
				this.showMeterCode = true
			},
			meterCodeClose() {
				this.showMeterCode = false
			},
			changeClose() {
				let page = this.currentPage
				this.showChangeCode = false
				return this.search()
			},
			search() {
				let code = this.select.code
				let account = this.select.account
				let name = this.select.owner_name
				let phone = this.select.owner_phone
				let type = this.select.type
				let nature = this.select.nature
				let page = this.currentPage
				let address = this.select.address
				this.$jssdk.file.list({
					code: code,
					account: account,
					owner_name: name,
					owner_phone: phone,
					type: type,
					page: page,
					nature: nature,
					address:address,
				}, (data) => {
					this.lists = data.meterList.data
					this.total = data.meterList.total
					for(var i = 0; i < data.meterList.data.length; i++) {
						if(data.meterList.data[i].nature == '0') {
							this.lists[i].nature = '居民'
						}
						if(data.meterList.data[i].nature == '1') {
							this.lists[i].nature = '自营'
						}
						if(data.meterList.data[i].nature == '2') {
							this.lists[i].nature = '联营'
						}
						if(data.meterList.data[i].nature == '3') {
							this.lists[i].nature = '出租'
						}
						if(data.meterList.data[i].nature == '4'){
							this.lists[i].nature = '物业动力'
						}
						if(data.meterList.data[i].nature == '5'){
							this.lists[i].nature = '居民配套'
						}
						if(data.meterList.data[i].nature == '9') {
							this.lists[i].nature = '备用'
						}
					}
					this.currentPage = data.meterList.current_page
				}, (err) => {
					return this.$message({
						type: 'warning',
						message: err.msg,
						duration: 1000
					})
				})
			},
			resetting() {
				this.select.code = ''
				this.select.owner_name = ''
				this.select.address = ''
				this.select.owner_phone = ''
				this.select.type = ''
				this.select.nature = ''
				this.select.account = ''
			},
			banCode(index, row) {
				let page = this.currentPage
				this.$confirm('确定禁用此表吗？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.$jssdk.file.ban({
						meter_id: row.id,
						status: '0'
					}, (data) => {
						this.$message({
							type: 'success',
							message: '禁用表成功',
							duration: 1000
						})
						return this.handleCurrentChange(page)
					}, (err) => {
						return this.$message({
							type: 'warning',
							message: err.msg,
							duration: 1000
						})
					})
				});
			},
			qiCode(index, row) {
				let page = this.currentPage
				this.$confirm('确定激活此表吗？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.$jssdk.file.ban({
						meter_id: row.id,
						status: '1'
					}, (data) => {
						this.$message({
							type: 'success',
							message: '激活表成功',
							duration: 1000
						})
						return this.handleCurrentChange(page)
					})
				});
			},
			resetCode(index, row) {
				this.$confirm('确定重置表查询密码？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.$jssdk.file.reset({
						meter_id: row.id
					}, (data) => {
						this.$message({
							type: 'success',
							message: '重置表密码成功',
							duration: 1000
						})
					},(err) =>{
						this.$message({
							type: 'warning',
							message: err.msg,
							duration: 1000
						})
					})
				});
			},
			infoCode(index, row) {
				this.meterCodeId = row.id
				this.showChangeCode = true
			},
			downCode() {
				//window.location.href="https://api-property.minegou.cn/file/list?memberid=whjcZ8d0RAzbNdK4OU8LHNSl9oqhM4z9&authkey=9cc592747ddc6dceceb40a62a461d841&is_export=1"
				let code = this.select.code
				let name = this.select.owner_name
				let phone = this.select.owner_phone
				let type = this.select.type
				let nature = this.select.nature
				let address = this.select.address
				this.$jssdk.file.list({
					code: code,
					owner_name: name,
					owner_phone: phone,
					type: type,
					is_export: '1',
					nature: nature,
					address:address,
					sort_by: this.prop,
					sort_to: this.order,
				}, (data) => {
					window.location.href = data.url
				})
			},
			handleSizeChange(val) {},
			handleCurrentChange(val) {
				let code = this.select.code
				let name = this.select.owner_name
				let phone = this.select.owner_phone
				let type = this.select.type
				let nature = this.select.nature
				let address = this.select.address
				this.$jssdk.file.list({
					code: code,
					owner_name: name,
					owner_phone: phone,
					type: type,
					page: val,
					nature: nature,
					sort_by: this.prop,
					sort_to: this.order,
					address:address
				}, (data) => {
					this.lists = data.meterList.data
					this.currentPage = data.meterList.current_page
					for(var i = 0; i < data.meterList.data.length; i++) {
						if(data.meterList.data[i].nature == '0') {
							this.lists[i].nature = '居民'
						}
						if(data.meterList.data[i].nature == '1') {
							this.lists[i].nature = '自营'
						}
						if(data.meterList.data[i].nature == '2') {
							this.lists[i].nature = '联营'
						}
						if(data.meterList.data[i].nature == '3') {
							this.lists[i].nature = '出租'
						}
						if(data.meterList.data[i].nature == '4'){
							this.lists[i].nature = '物业动力'
						}
						if(data.meterList.data[i].nature == '5'){
							this.lists[i].nature = '居民配套'
						}
						if(data.meterList.data[i].nature == '9') {
							this.lists[i].nature = '备用'
						}
					}
				})
			},
		},
		components: {
			addMeterCode,
			changeCode
		},
		computed:{
			naturesData(){
				return this.natures = this.nature
			},
			...mapState(['nature'])
		},
	}
</script>

<style>
	.add_meter_code {
		width: 200px;
		text-align: left;
	}
</style>


// WEBPACK FOOTER //
// meterFile.vue?725024ae